import { APP_CONTEXT } from '@/utils/context';
import { checkPermissions } from '@/utils/utils';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import Styled from './page-tab-selector-component-style';

const RenderTabContent = ({ tab }) => {
  const match = useMatch(tab.path);
  const { state } = useLocation();

  return (
    <Styled.Tab
      key={tab.label}
      active={match}
      to={tab.path}
      state={tab?.useLocation && state}
    >
      <Styled.Label active={match}>{tab.label}</Styled.Label>
    </Styled.Tab>
  );
};

RenderTabContent.propTypes = {
  tab: PropTypes.shape({
    label: PropTypes.string,
    path: PropTypes.string,
    useLocation: PropTypes.bool,
  }).isRequired,
};

/**
 * Tab Selector component to display tabs and their content.
 * @param {object} props The component props.
 * @param {Array} props.tabs The tabs to display.
 * @param {func} props.typeCheck The function to check the type of the tab.
 * @returns {JSX.Element} The rendered Tab Selector component.
 */
const TabSelector = ({ tabs, typeCheck }) => {
  const { permissions, isSuper } = useContext(APP_CONTEXT);
  // Check permissions and display tabs
  const validTabs = tabs
    .filter((tab) => {
      if (tab.permissions) {
        if (isSuper || checkPermissions(permissions, tab.permissions, true)) {
          return true;
        }
        return false;
      }
      return true;
    })
    .filter((tab) => {
      if (typeCheck && tab.type) {
        return typeCheck(tab.type);
      }
      return true;
    });
  return (
    <Styled.TabContainer>
      {validTabs.map((tab) => (
        <RenderTabContent key={tab.path} tab={tab} />
      ))}
    </Styled.TabContainer>
  );
};

TabSelector.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  typeCheck: PropTypes.func,
};

TabSelector.defaultProps = {
  tabs: [],
  typeCheck: undefined,
};

export default TabSelector;
